<template>
  <div class="background-wrapper-other">
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/myfavoritethings">私のお気に入り</router-link></li>
        </ul>
      </div>
    </div>
    <div class="myfavoritethings">
      <div class="container">
        <div class="container-child">
          <div class="myfavoritethings__title categoty_title_style">
            <h2>MY FAVORITE THINGS<span>私のお気に入り</span></h2>
            <div class="myfavoritethings__select__category">
              <div class="myfavoritethings__select__category__btn" :class="{active: selectActive}" @click="open_select">他のテーマを選択<button class="btn_expand" :class="{active: selectActive}"></button></div>
              <ul class="myfavoritethings__select__category__list" :class="{active: selectActive}">
                <li 
                  v-for="(item, index) in photo_theme"
                  :key="index"
                >
                  <router-link 
                    :class="{active: item.theme_id == photo_theme_categor_id }"
                    :to="'/myfavoritethings/'+ item.theme_id"
                  >
                    {{ item.theme_name }}
                  </router-link>
                </li>
              </ul>
            </div>
            <p class="btn_interaction">ボタンをクリックすると他のテーマをご確認いただけます。</p>
            <router-link class="btn_link" to="/myfavoritethings/form">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 22">
                <path d="M16,9.28c-2.15,0-3.88,1.55-3.88,3.46s1.74,3.46,3.88,3.46,3.88-1.55,3.88-3.46-1.74-3.46-3.88-3.46Z"/>
                <path d="M29.92,4.36h-3.66c-.82,0-1.56-.43-1.89-1.09l-1.1-2.17c-.33-.66-1.08-1.09-1.89-1.09h-10.75c-.82,0-1.56.43-1.9,1.09l-1.1,2.17c-.34.66-1.08,1.09-1.89,1.09h-3.66c-1.15,0-2.08.83-2.08,1.85v13.94c0,1.02.93,1.85,2.08,1.85h27.85c1.15,0,2.08-.83,2.08-1.85V6.21c0-1.02-.93-1.85-2.08-1.85ZM16,19.66c-4.29,0-7.76-3.1-7.76-6.92s3.47-6.92,7.76-6.92,7.76,3.1,7.76,6.92-3.47,6.92-7.76,6.92Z"/>
              </svg>
              <span>投稿はこちら</span>
            </router-link>
          </div>
          <div class="myfavoritethings-category">

            <div class="myfavoritethings-category__title" v-if="checkDataExists">
              <p>{{ photo_theme_category.theme_name }}</p>
            </div>

            <MyfavoritethingsList :id="photo_theme_categor_id" v-if="checkDataExists"/>

            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 30px;">
                <PuSkeleton/>
            </div>

            <div class="myfavoritethings-category__empty" v-if="displayEmpty">
              <p>現在ご案内する情報はありません</p>
            </div>

          </div>
          <div class="myfavoritethings__title">
            <router-link class="btn_link btn_back" to="/myfavoritethings">
              <span>MY FAVORITE THINGSに戻る</span>
            </router-link>
            <br></br>
            <router-link class="btn_link" to="/myfavoritethings/form">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 22">
                <path d="M16,9.28c-2.15,0-3.88,1.55-3.88,3.46s1.74,3.46,3.88,3.46,3.88-1.55,3.88-3.46-1.74-3.46-3.88-3.46Z"/>
                <path d="M29.92,4.36h-3.66c-.82,0-1.56-.43-1.89-1.09l-1.1-2.17c-.33-.66-1.08-1.09-1.89-1.09h-10.75c-.82,0-1.56.43-1.9,1.09l-1.1,2.17c-.34.66-1.08,1.09-1.89,1.09h-3.66c-1.15,0-2.08.83-2.08,1.85v13.94c0,1.02.93,1.85,2.08,1.85h27.85c1.15,0,2.08-.83,2.08-1.85V6.21c0-1.02-.93-1.85-2.08-1.85ZM16,19.66c-4.29,0-7.76-3.1-7.76-6.92s3.47-6.92,7.76-6.92,7.76,3.1,7.76,6.92-3.47,6.92-7.76,6.92Z"/>
              </svg>
              <span>投稿はこちら</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";
import { metaData, getListThemeName } from '@/utils/helper';

export default {
  name: "MyfavoritethingsCategory",
  components: {
    MyfavoritethingsList: () =>
      import("@/components/common/myfavoritethings/MyfavoritethingsList.vue"),
    VueSkeletonLoader: () => {
      VueSkeletonLoader;
    },
  },
  data() {
    return {
      selectActive: false,
      photo_theme: [],
      photo_theme_category: "",
      photo_theme_categor_id: this.$route.params.id,
      isLoading: true,
      checkDataExists: false,
      displayEmpty: false,
    };
  },
  methods: {
    open_select() {
      this.selectActive = !this.selectActive;
    },
    getPage: function () {

      this.isLoading = true

      getListThemeName(`/photo_theme`)
        .then((response) => {
          setTimeout(()=>{

            this.photo_theme = response.data;

            if( this.photo_theme != null) {
              if(this.photo_theme.find(item => item.theme_id === Number(this.$route.params.id)) != undefined ) {
                this.photo_theme_category = this.photo_theme.find(item => item.theme_id === Number(this.$route.params.id));
              } else {
                this.$router.push('/NotFound')
              }
            }
            
            this.checkDataExists = this.photo_theme_category.theme_name != null;
            this.displayEmpty =  !this.checkDataExists;
            this.isLoading = false;

            metaData(
              `${this.photo_theme_category.theme_name ? this.photo_theme_category.theme_name : '私のお気に入り'} | HARUMIFLAGタウンポータル`,
              '中央区晴海・HARUMIFLAGのMY FAVORITE THINGSのテーマごとに写真を一覧表示するページです。',
              'HARUMIFLAGタウンポータル',
              'article',
            )
            
          },500)
        })
        .catch((e) => {
          console.log(e);
          this.$router.push('/timeout')
        });
    },
  },
  created() {

    this.getPage();
  },
};
</script>
